import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="gift">
        <path
          id="Outlined"
          d="M12 7.99994V20.9999M12 7.99994C11.6383 6.50934 11.0154 5.23501 10.2127 4.34311C9.41001 3.45121 8.46467 2.98314 7.49998 2.99995C6.83694 2.99995 6.20106 3.26334 5.73222 3.73218C5.26338 4.20102 4.99998 4.83691 4.99998 5.49995C4.99998 6.16299 5.26338 6.79887 5.73222 7.26772C6.20106 7.73656 6.83694 7.99995 7.49998 7.99995M12 7.99994C12.3617 6.50934 12.9845 5.23501 13.7872 4.34311C14.59 3.45121 15.5353 2.98314 16.5 2.99995C17.163 2.99995 17.7989 3.26334 18.2678 3.73218C18.7366 4.20102 19 4.83691 19 5.49995C19 6.16299 18.7366 6.79887 18.2678 7.26772C17.7989 7.73656 17.163 7.99995 16.5 7.99995M19 11.9999V18.9999C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7892 17.5304 20.9999 17 20.9999H6.99998C6.46955 20.9999 5.96084 20.7892 5.58577 20.4142C5.2107 20.0391 4.99998 19.5304 4.99998 18.9999V11.9999M2.99998 8.99994C2.99998 8.73472 3.10534 8.48037 3.29288 8.29283C3.48041 8.1053 3.73477 7.99994 3.99998 7.99994H20C20.2652 7.99994 20.5196 8.1053 20.7071 8.29283C20.8946 8.48037 21 8.73472 21 8.99994V10.9999C21 11.2652 20.8946 11.5195 20.7071 11.707C20.5196 11.8946 20.2652 11.9999 20 11.9999H3.99998C3.73477 11.9999 3.48041 11.8946 3.29288 11.707C3.10534 11.5195 2.99998 11.2652 2.99998 10.9999V8.99994Z"
          stroke="#1E293B"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-gift" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
